import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import SelectorField from './selector-field';

export default Component('tr-priority-select-field', {
  extends: [SelectorField],

  mixins: [eventListenerMixin],

});
